import { Controller, useFormContext, useWatch } from "react-hook-form";
import { View } from "react-native-ui-lib";
import { Label, TextField } from "@towersystems/roam-common-native";
import { ProductFormValues, FormInputProps } from "../../types";
import { useTranslation } from "../../../../../../utilities/i18n";

export type PriceLookUpFormInputProps = FormInputProps & {};

export const PriceLookUpFormInput = ({}: PriceLookUpFormInputProps) => {
  const { control } = useFormContext<ProductFormValues>();
  const { t } = useTranslation("product");

  const globalDisable = useWatch({ control, name: "globalDisable" });

  return (
    <View>
      <Label label={t("form.price_lookup.label")}></Label>
      <Controller
        name="priceLookup"
        control={control}
        disabled={globalDisable}
        render={({
          field: { onChange, value, onBlur, disabled },
          fieldState: { error },
        }) => (
          <TextField
            onBlur={onBlur}
            value={value ?? ""}
            onChangeText={onChange}
            readonly={disabled}
            validationMessage={error ? error.message : undefined}
            placeholder={t("form.price_lookup.placeholder")}
          />
        )}
      />
    </View>
  );
};
